@use 'sass:color';
@use "../../scss/util";

/******** FLEX PROPS ********/
.contactBox {
    box-sizing: border-box;
    padding: 40px 20px;
}

.contact {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;

    &PhotoBox, &MessageBox { flex: 100% }
    
    @include util.mq(util.$md) { &MessageBox { flex: 0 0 util.$sm } }
    
    @include util.mq(util.$lg) {
        max-width: util.$lg;
        margin: 0 auto;
        
        &PhotoBox { flex: 1 }
        &MessageBox { flex: 1 }
    }
}








/******** GENERAL STYLES ********/
.contact {
    color: util.$eBlueDark;
    padding: 0 20px;
    
    &PhotoBox, &MessageBox, &CtaBox { text-align: center }
    
    &PhotoBox {
        text-align: center;
        
        img {
            display: inline-block;
            max-width: 75%;
            height: auto;
            border-radius: 50%;

            @include util.mq(util.$sm) { max-width: 250px }
        }

        &Name {
            @include util.font-heading();
            font-size: 3em;
            line-height: 1.2em;
            margin: 20 0 10px 0;
            @include util.mq(util.$sm) { font-size: 2.3em; }
        }

        &Title {
            font-size: 2em;
            line-height: 1.1em;
            font-weight: 400;
            margin: 0 0 20px 0;
            color: util.$eBlue;
            @include util.mq(util.$sm) { font-size: 1.7em; }
        }
    }
    
    &MessageBox {
        font-size: 1.4em;
        line-height: 1.5em;
        text-align: center;

        @include util.mq(util.$md) {
            font-size: 1.6em;
        }
    }
    
    &CtaLink {
        @include util.button(util.$eGreen, white);
        display: inline-block;
        margin: 0 20px 15px;
        min-width: 150px;
        font-weight: 700;
        font-size: 1.1em;

        &:hover { 
            background: color.scale(util.$eGreen, $lightness: -20%);
            transition: background .3s ease-in-out;
        }
    }
}

